module.exports = __webpack_public_path__ + "static/img/main.a38f413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/rorando/main.png
// module id = 2b3G
// module chunks = 0